import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-media gfu-media--middle _mb-3"
}
const _hoisted_2 = { class: "gfu-thumb" }
const _hoisted_3 = { class: "gfu-media__body _ml-3" }
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return ($options.isProjectInfoVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_image, {
            src: $props.currentProject.thumbImageUrl,
            width: "36",
            height: "36",
            class: "gfu-thumb__item",
            loading: "lazy",
            alt: $props.currentProject.name
          }, null, 8 /* PROPS */, ["src", "alt"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "gfu-bt gfu-bt--b1",
            "data-qa": `contact-context-project:${$props.currentProject.projectID}`
          }, _toDisplayString($props.currentProject.name), 9 /* TEXT, PROPS */, _hoisted_4),
          _createElementVNode("div", {
            class: "gfu-bt gfu-bt--caption _tc--light",
            "data-qa": `contact-context-creator:${$props.currentProject.creator.creatorID}`
          }, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Contact.ContactSearchResultByCreatorLabel, $props.currentProject.creator.name)), 9 /* TEXT, PROPS */, _hoisted_5)
        ])
      ]))
    : (_openBlock(), _createElementBlock("h4", {
        key: 1,
        class: "gfu-hd gfu-hd--h4",
        "data-qa": `contact-form-subcategory:${$options.currentCategoryGroupName}`
      }, _toDisplayString($options.currentCategoryGroupName), 9 /* TEXT, PROPS */, _hoisted_6))
}